import { createContext, ReactNode, useState, useContext, useEffect } from 'react';

import useAxios from 'axios-hooks';

import { getStorageValue, StorageKeys } from 'utils/local.storage.utils';

interface SportContextType {
  currentSport: Sport;
  sportId: number;
  setCurrentSport: (sport: Sport) => void;
  sports: Array<Sport>;
}

const SportContext = createContext<SportContextType>({} as SportContextType);

export const SportProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const sportId = getStorageValue(StorageKeys.SportId);
  const [currentSport, setCurrentSport] = useState<Sport>(
    sportId && {
      id: parseInt(sportId),
      name: '',
      allowsDoubles: false,
      allowsPlayers: false,
    },
  );

  const [{ data }] = useAxios({ url: '/sports', params: { pageSize: 200 } });

  useEffect(() => {
    if (data?.items) {
      // Sports are loaded. Find if the current sport exists and replace it with a real value.
      setCurrentSport(current => {
        if (current) {
          const sport = data?.items.find(el => el.id === current.id);
          if (sport) {
            return sport;
          }
        }
        return current;
      });
    }
  }, [data?.items]);

  return (
    <SportContext.Provider
      value={{
        currentSport,
        sportId: currentSport?.id,
        setCurrentSport,
        sports: data?.items || [],
      }}
    >
      {children}
    </SportContext.Provider>
  );
};

export const useSports = () => useContext(SportContext);
